<template>
  <div id="app">
        <router-view />
<!--    <img src="../static/image/display/display.jpg" style="object-fit: cover;width:100%;height:100%">-->
  </div>
</template>

<script>
export default {
  name: "App",
  created() {
    window.localStorage.setItem('sigUrl', window.location.href)
  },
  mounted() {
    document.addEventListener("WeixinJSBridgeReady", function () {
      WeixinJSBridge.invoke("setFontSizeCallback", {
        fontSize: '2'
      });
    }, false);
  },

};

</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

body {

  -webkit-text-size-adjust: 100% !important;

}
</style>



// WEBPACK FOOTER //
// src/App.vue